import { createAction, props } from '@ngrx/store';

import { CandidateJobStatus, Association } from '@shared/models';

export const submitHiringManagerCandidateAction = createAction(
  '[Hiring Manager Status] Submit Action For Hiring Manager Candidate',
  props<{
    candidateId: number;
    jobId: number;
    associationId: number;
    noteComment: string;
    isBatchOperation?: boolean;
  }>(),
);

export const submitBatchHiringManagerCandidateAction = createAction(
  '[Hiring Manager Status] Batch Submit Action For Hiring Manager Candidate',
  props<{
    jobId: number;
    associations: Association[];
    noteComment: string;
  }>(),
);

export const rejectHiringManagerCandidateAction = createAction(
  '[Hiring Manager Status] Reject Action For Hiring Manager Candidate',
  props<{
    candidateId: number;
    jobId: number;
    associationId: number;
    noteComment: string;
    showSnackbar?: boolean;
    isBatchOperation?: boolean;
  }>(),
);

export const rejectBatchHiringManagerCandidateAction = createAction(
  '[Hiring Manager Status] Batch Reject Action For Hiring Manager Candidate',
  props<{
    jobId: number;
    associations: Association[];
    noteComment: string;
  }>(),
);

export const advanceHiringManagerCandidateAction = createAction(
  '[Hiring Manager Status] Advance Action For Hiring Manager Candidate',
  props<{
    candidateId: number;
    jobId: number;
    associationId: number;
    noteComment: string;
    showSnackbar?: boolean;
    isBatchOperation?: boolean;
  }>(),
);

export const advanceBatchHiringManagerCandidateAction = createAction(
  '[Hiring Manager Status] Batch Advance Action For Hiring Manager Candidate',
  props<{
    jobId: number;
    associations: Association[];
    noteComment: string;
  }>(),
);

export const conductHiringManagerCandidateActionSuccess = createAction(
  '[Hiring Manager Status] Conduct Action For Hiring Manager Candidate Success',
  props<{
    hiringManagerStatus: CandidateJobStatus;
    associationId: number;
    noteComment: string;
    showSnackbar?: boolean;
    isBatchOperation?: boolean;
  }>(),
);

export const assignCandidateToHiringManagerFail = createAction(
  '[Hiring Manager Status] Assign Candidate to Hiring Manager Fail',
  props<{ error: any }>(),
);

export const loadCandidateHiringManagerStatus = createAction(
  '[Hiring Manager Status] Load Candidates Hiring Manager Status',
  props<{ jobId: number; candidatesIds: number[] }>(),
);

export const loadCandidateHiringManagerStatusSuccess = createAction(
  '[Hiring Manager Status] Load Candidate Hiring Manager Status Success',
  props<{ statuses: CandidateJobStatus[] }>(),
);
